import { useState, useEffect, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { IFilters } from 'types/configurations'
import { removeFinalSpaces } from 'helper/regex'
import { InputSearch } from 'components/InputSearch'
import { InputSelect } from 'components/InputSelect'
import { NewSectorModal } from 'components/Modals/NewSector'
import ActionStatus from 'components/ActionStatus'
import {
  CleanFilters,
  CreateButton,
  FilterButton,
  LineUser,
  Subtitle,
  Title,
} from 'pages/Configurations/Users/styles'
import { CreateContainer, SectorsContainer, SectorsFilters } from 'pages/Configurations/Sectors/styles'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState, Message, MessageTypeInitiator } from 'types/global'
import { SectorAction, SectorReducer, Sector, SectorList } from 'types/sector'
import SectorActions from 'actions/Sector'
import SectionService from 'services/Sector'
import { titleTableSectors } from 'components/SharedTable/models'
import { LocationAction,LocationReducer } from 'types/location'
import LocationActions from 'actions/Location'
import { TypeTableColums } from 'types/user'
import Table from 'components/Table'

const Sectors = () => {
  const { control, register, getValues, watch, handleSubmit, setValue } =
    useForm()
  const [message, setMessage] = useState<Message>(MessageTypeInitiator)
  let setMessageSuccess = (text:string) => setMessage({visible: true, status: 1, text: text} as Message)
  let setMessageError = (text:string) => setMessage({visible: true, status: 0, text: text} as Message)
  const [selectedFilters, setSelectedFilters] = useState<IFilters>({})
  const [sectorsData, setSectorsData] = useState<string[]>()
  const [sectorExists, setSectorExists] = useState(false)
  const [actionStatus, setActionStatus] = useState(false)
  const [modalNewSectorOpen, setmodalNewSectorOpen] = useState(false)

  const sectorDispatch:Dispatch<SectorAction> = useDispatch<Dispatch<SectorAction>>()
  const sectorSelector:SectorReducer = useSelector((state:RootReducerState) => state.sectorReducers)
  const locationSelector:LocationReducer = useSelector((state:RootReducerState) => state.locationReducers)
  const sectorName = watch('sectorName')
  const unity = watch('unity')
  const [paginationItensByPage, setPaginationItensByPage] = useState<number>(10)
  const locationDispatch: Dispatch<LocationAction> = useDispatch<Dispatch<LocationAction>>()
  const [selectedLocation, setSelectedLocation] = useState<string>("")

  const [sectorOrder, setSectorOrder] = useState<any>({field: 'u_name', order: 'ORDERBY'})
  const [sectorTableCurrentPage, setSectorTableCurrentPage] = useState<number>(0)

  const [showCleanFilter, setShowCleanFilter] = useState<boolean>(false)
  
  const filters = {
    unity: watch('unity') !== 'Unidade' ? watch('unity') : undefined,
    searchParams: getValues('searchSector')?.toLowerCase() || undefined,
  }

  const searchSector = watch('searchSector')

  /**
   * @TODO : Precisa documentar
   */
  const handleFilterWithSearch = () => {


  }

  const handleCleanInputSearch = () => {
    setSectorsData(sectorSelector.sectorsListNames)
    setSelectedFilters({
      sector: selectedFilters.sector,
    })
    setValue('searchSector', undefined)
  }

  const handleCleanFilters = () => {
    setValue('unity', '')
    setShowCleanFilter(false)
    setValue('searchSector', '')
    SectorActions.getAllSectorsPaginate(sectorDispatch, `0`, `${paginationItensByPage}`)
  }

  const handleFilterTable = (data: any) => {
    const filteredUsers = sectorSelector.sectorsListNames?.filter((item) => {
      if (data?.unity === 'Unidade') {
        setSelectedFilters({})
        return sectorsData
      }

      if (item === data?.unity) {
        setSelectedFilters({ unity: item })
        return item
      }
    })

    setSectorsData(filteredUsers)
  }

  const handleClickNewSector = (data: { sectorName: string }) => {

    const newSector:Sector = {u_name: removeFinalSpaces(data?.sectorName)}
    if (removeFinalSpaces(data?.sectorName).length < 3) {
      return
    }
    SectionService.createNewSector(newSector)
        .catch(console.error)
        .then((response:any) => {
          SectorActions.createNewSector(sectorDispatch, response.data.result)
          setMessageSuccess(`Novo setor (${newSector.u_name}) cadastrado com sucesso!`)
          handleCloseModal()
          setValue('sectorName', '')
          setTimeout(() => {
            setMessage(MessageTypeInitiator)
          }, 3000)
    })
  }

  const handleClickOpenModalNewSector = () => {
    setmodalNewSectorOpen(true)
  }

  const handleCloseModal = () => {
    setmodalNewSectorOpen(false)
    setValue('sectorName', '')
  }

  /**
   * Esse é o metodo usado para mudar a paginação, 
   * aqui o offset é chamado via callback quando algum botão na paginação é clicado
   * Esse offset é enviado para o ServiceNow via webservice junto com o numero de itens por pagina
   * O Action pega o retorno desse webservice e 
   * grava no Redux usando a propriedade 'locationSectorList' do LocationReducer
   * @param offset - Numero de retorno ao clicar em um item de paginação
   */
  const handlerPaginationTableLocationSector = (offset:number) => {
    setSectorTableCurrentPage(offset)//mudando o offset para acompanhar o state até o componente Paginate
    getAllSectorsPaginate(`${offset}`)
  }

  /**
   * Evento usado para carregar os setores de acordo com a unidade selecionada
   */
  const onChangeLocation = useCallback((value) => {
        setValue('unity', value)   
  }, [])

  useEffect(() => {
    LocationActions.getAllLocations(locationDispatch)
    SectorActions.getAllSectorsPaginate(sectorDispatch, `0`, `${paginationItensByPage}`)
  }, [])

  /**
   * Ao re-ordenar coloco o offset para lista apartir da primeira página
   */
  useEffect(() => {
    setSectorTableCurrentPage(0)
    getAllSectorsPaginate()
  }, [sectorOrder])
  
  /**
   * Usado para capturar o valor de ordenação escolhido na Table
   * @param orderFieldSelected  - Valor retornado do componete Table ao clicar na ordenação
   */
  const handlerTableOrderByField = (orderFieldSelected: any) => {
    setSectorOrder(orderFieldSelected)
  }
  /**
   * Evento que dispara o filtro principal
   * @param event 
   */
  const doFilter = (event: any) => {
    setShowCleanFilter(true)
    getAllSectorsPaginate()
  }
  /**
   * Chamada principal que renderiza a tabela principal, junto com os filtros e ordenação
   * @returns 
   */
  const getAllSectorsPaginate = (offset:string = `0`) => SectorActions.getAllSectorsPaginate(sectorDispatch, 
                                                                          offset, 
                                                                          `${paginationItensByPage}`, 
                                                                          sectorOrder, 
                                                                          searchSector, 
                                                                          unity)
  
  return (
    <>
      <NewSectorModal
        handleSubmit={handleSubmit}
        handleClickNewSector={handleClickNewSector}
        register={register}
        sectorExists={sectorExists}
        setSectorExists={setSectorExists}
        isOpen={modalNewSectorOpen}
        handleCloseModal={handleCloseModal}
        sectorName={sectorName}
      />
      <SectorsContainer>
        <CreateContainer
          onSubmit={handleSubmit(handleClickNewSector as any)}
          className='mb-10'
        >
          <CreateButton type='button' onClick={handleClickOpenModalNewSector}>
            + Criar novo setor
          </CreateButton>
        </CreateContainer>

        {message.visible && (
                    <ActionStatus
                        text={message.text}
                        status={message.status}
                    />
        )}
        
        <LineUser />

        <Title>Lista de setores</Title>

        <Subtitle>
          Confira abaixo a lista de todos os setores cadastrados, e caso deseje
          verificar todos os setores de uma Unidade específica, faça a busca
          pelo filtro.
        </Subtitle>

        <SectorsFilters onSubmit={handleSubmit(handleFilterTable)}>
          <div className='flex gap-2'>
            <div>
              <InputSelect
                searchPlaceHolder="Buscar"
                onChange={onChangeLocation}
                defaultValue={selectedLocation}
                styleContainer="w-[360px]"
                styleBoxOptions="w-[360px] top-[55px]"
                label="Unidade"
                name="unity"
                control={control}
                onBlur={() => { 

                }}
                data={locationSelector.locationsList
                    ?.map((l) => ({
                        value: l.sys_id,
                        label: l.name
                    }))
                    .sort((o1, o2) =>
                        o1.label.localeCompare(o2.label)
                    )}
                placeholder="Selecionar"
              />
              {showCleanFilter && (
                <CleanFilters onClick={handleCleanFilters}>
                  Limpar Filtros
                </CleanFilters>
              )}
            </div>

            <FilterButton className='mt-[16.5px]' onClick={doFilter}>Filtrar</FilterButton>
          </div>

          <div className='mt-[16.5px]'>
            <InputSearch
              handleCleanInputSearch={handleCleanInputSearch}
              searchValue={filters?.searchParams}
              onBlur={handleFilterWithSearch}
              name='searchSector'
              register={register}
              className='w-[448px]'
              placeholder='Buscar setor'
            />
          </div>
        </SectorsFilters>

        <Table
          titleTable={titleTableSectors}
          selectedFilters={selectedFilters as IFilters}
          tableData={sectorSelector.sectorsListDataTable}
          paginationTotal={sectorSelector.sectorAllCount}
          paginationItensByPage={paginationItensByPage}
          paginationNumberSelectedPage={handlerPaginationTableLocationSector}
          orderCollumnSelected={
            handlerTableOrderByField
          }
          paginationCurrentPage={sectorTableCurrentPage}
        />

      </SectorsContainer>
    </>
  )
}

export { Sectors }